module.exports = __webpack_public_path__ + "img/produit_local.3db5473a.png";